import { Flex, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import Icon from "../../../../Icon"
import {
  getIntegrationErrorText,
  getIntegrationLabel
} from "../../../../Utils/integrationSuggestions"
import { SUGGESTIONS_STATUS } from "../constants/suggestions"
import { selectSuggestions } from "../redux/configure.slice"

const { Text } = Typography

// What the Step 3 first fill found for the ARN field (CHA1-4909, §11.9): the same texts and
// cases as Alerts onboarding.
const ArnSuggestionsOutcome = () => {
  const { t } = useTranslation()
  const { status, integrations } = useSelector(selectSuggestions)

  if (status === SUGGESTIONS_STATUS.FAILED) {
    return (
      <Text type="warning">
        <Icon type={"alert_triangle_error"} />{" "}
        {t("Couldn't load ARN suggestions. You can enter codes manually.")}
      </Text>
    )
  }

  if (status !== SUGGESTIONS_STATUS.DONE) return null

  const failed = integrations.filter((integration) => integration.error)
  const withoutArns = integrations
    .filter((integration) => !integration.error && !integration.has_arn_codes)
    .map((integration) => getIntegrationLabel(integration.provider))

  if (!failed.length && !withoutArns.length) return null

  return (
    <Flex vertical gap={4}>
      {failed.map(({ provider, error }) => (
        <Text key={provider} type="warning">
          <Icon type={"alert_triangle_error"} /> {getIntegrationLabel(provider)}:{" "}
          {t(getIntegrationErrorText(error))}
        </Text>
      ))}
      {withoutArns.length ? (
        <Text type="secondary">
          {t("No eligible Visa refund ARNs from the last 90 days found in _integrations_.", {
            integrations: withoutArns.join(", ")
          })}
        </Text>
      ) : null}
    </Flex>
  )
}

export default ArnSuggestionsOutcome
